<template>
    <header class="dashboard-header" ref="container">
        <div class="dashboard-header-background" v-if="headerImage.show"></div>

        <div class="dashboard-overview">
            <div class="dashboard-overview-title">
                Mit <br />
                overblik
            </div>
            <kpi-notification @openModal="openModal" @closeModal="closeModal"/>
        </div>

        <nav class="dashboard-navigation">
            <ul class="dashboard-navigation-group">
                <li class="dashboard-navigation-item" v-for="(item, index) in tabGroup1()" :key="index">
                    <a class="dashboard-navigation-link" :href="'#' + item.name" :class="{ 'js-selected': getSelectedTab === item.name }" @click="changeWorkView(item.name)">
                        <icon class="small-svg fill-white" :name="item.name.slice(0, -1)" />{{ item.name | tabsToDanish }}
                    </a>
                </li>
            </ul>
            <ul class="dashboard-navigation-group">
                <li class="dashboard-navigation-item" v-for="(item, index) in tabGroup2()" :key="index">
                    <a class="dashboard-navigation-link" :href="'#' + item.name" :class="{ 'js-selected': getSelectedTab === item.name }" @click="changeWorkView(item.name)">
                        <icon class="small-svg fill-white" :name="item.name.slice(0, -1)" />{{ item.name | tabsToDanish }}
                    </a>
                </li>
            </ul>
            <ul class="dashboard-navigation-group">
                <li class="dashboard-navigation-item">
                    <!-- <router-link class="dashboard-navigation-link" title="Åbn stort kort" :to="{ name: 'map' }">
                        <icon class="small-svg fill-white" name="maplocation" />Kort
                    </router-link> -->
                </li>
            </ul>
        </nav>
    </header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import kpiNotification from './../../shared/kpi/kpi.vue'

export default {
    components: {
        'kpi-notification': kpiNotification
    },
    props: {
        headerImage: {
            type: Object,
            default: {
                show: true
            }
        }
    },
    data () {
        return {
        }
    },
    computed: {
        ...mapGetters({
            getSelectedTab: 'getSelectedTab',
            tabs: 'getTabs'
        })
    },
    methods: {
        ...mapActions({
            setSelectedTab: 'setSelectedTab'
        }),

        openModal (type, data) {
            this.$emit('openModal', type, data)
        },
        closeModal () {
            this.$emit('closeModal')
        },
        changeWorkView (selectedView) {
            if (this.getSelectedTab !== selectedView) {
                this.setSelectedTab(selectedView)
            }
        },
        tabGroup1 () {
            return this.tabs.filter(tab => tab.name !== 'routines' && tab.name !== 'templates')
        },
        tabGroup2 () {
            return this.tabs.filter(tab => tab.name === 'routines' || tab.name === 'templates')
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/dashboard-header.vue